import { getMonthYearBound, parsePeriodInput } from '../../utils/monthYearParse';

export type PmoWorklogPeriodIso = {
  worklogStartDate: string | null;
  worklogEndDate: string | null;
};

const formatIsoDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/** Qualquer campo De/Até preenchido (rascunho parcial). */
export const hasPmoWorklogPeriod = (periodStart: string, periodEnd: string): boolean =>
  Boolean(periodStart.trim() || periodEnd.trim());

/** De/Até completos e válidos — obrigatório para calcular KPIs de HH no período. */
export const hasCompletePmoWorklogPeriod = (periodStart: string, periodEnd: string): boolean => (
  Boolean(parsePeriodInput(periodStart) && parsePeriodInput(periodEnd))
);

/** Converte De/Até (dd/mm/aaaa ou mm/aaaa) em datas ISO para filtro de worklog no backend. */
export const pmoPeriodToWorklogIsoDates = (
  periodStart: string,
  periodEnd: string,
): PmoWorklogPeriodIso => {
  const start = periodStart.trim() ? getMonthYearBound(periodStart, 'start') : null;
  const end = periodEnd.trim() ? getMonthYearBound(periodEnd, 'end') : null;
  return {
    worklogStartDate: start ? formatIsoDate(start) : null,
    worklogEndDate: end ? formatIsoDate(end) : null,
  };
};
